<template>
  <div>
    <el-dialog
      v-if="visible"
      show-close
      :visible="visible"
      width="400px"
      :title="title"
      :close-on-click-modal="false"
      :before-close="() => $refs.main.cancel()"
      append-to-body
      v-el-dialog-drag
    >
      <Main
        ref="main"
        @close="close()"
        :expoMeetingCode="expoMeetingCode"
        :tskRemarkCode="tskRemarkCode"
        :tskInfoCode="tskInfoCode"
      />
      <span slot="footer">
        <el-button size="small" @click="$refs.main.cancel()">
          {{ this.$l('INDEX.btn_cancel') || '取消' }}
        </el-button>
        <el-button type="primary" size="small" @click="upload()">
          {{ $l('INDEX.btn_upload') || '上传' }}
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import Main from './main.vue'
export default {
  components: { Main },
  props: {
    visible: { type: Boolean, default: false },
    title: { type: String, default: '' },
    expoMeetingCode: { type: String, default: '' },
    tskInfoCode: { type: String, default: '' },
    tskRemarkCode: { type: String, default: '' },
  },
  methods: {
    close() {
      this.$emit('close')
      this.$emit('update:visible', false)
    },
    async upload() {
      const data = await this.$refs.main.upload()
      if (!data?.length) return
      this.$emit('upload', data)
      this.close()
    },
  },
}
</script>
